<template>
  <div class="home">
    <b-container fluid>
      <h1>Welcome to the Facility and Provider Licensing System</h1>
      <p style="margin-top:25px; margin-bottom:26px;">
        All facilities and providers pursuing a license from the Minnesota Department of Health must complete their initial application
        through this system.
      </p>
      <div class="font-weight-bold">Disclaimer</div>
      <p>
        You have entered a state government information system with data owned by the Minnesota Department of Health. To protect the
        department’s rights and property, you consent by using the system to having MDH monitor, intercept, record, copy, audit, inspect or
        otherwise capture and/or analyze all use of the system and you agree to follow all state laws, policies and agreements, including
        but not limited to the Minnesota Government Data Practices Act (Minnesota Statutes, chapter 13). Any unauthorized access or use of
        the site is prohibited and may result in criminal, civil and/or administrative action.
      </p>

      <b-row>
        <b-col>
          <b-button variant="primary" @click="login" v-if="!authenticated">Login or Create Account</b-button>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
  import axios from "axios"
  import axiosRetry from 'axios-retry'
  import ConfigService from "@/services/ConfigService";
  import LocalStorageService from '@/services/LocalStorageService';

  axiosRetry(axios, { retries: 3,
    retryDelay: axiosRetry.exponentialDelay  })

  export default {
    data: () => ({
    }),
    created() {
      document.title = "Facility and Provider Licensing System"
    },
    computed: {
      authenticated: function() {
        if (this.$keycloak) {
          return this.$keycloak.authenticated;
        } else {
          return false;
        }
      },
    },
    methods: {
      login () {
        const localStorageService = LocalStorageService.getService();
        localStorageService.clearAuthTokens();
        const loginUrl = this.$keycloak.createLoginUrl()
        window.location.replace(loginUrl)
      },
    },
  }
</script>